import Vue from "vue";
import App from "./App.vue";
import VueYoutube from "vue-youtube";
import VueScreenSize from "vue-screen-size";
import VueVimeoPlayer from 'vue-vimeo-player';

Vue.use(VueScreenSize);
Vue.use(VueYoutube);
Vue.use(VueVimeoPlayer);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#rarest-day-map");
